var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',_vm._g(_vm._b({staticStyle:{"border":"none"},style:({'color': _vm.color}),attrs:{"color":_vm.bgColor}},'el-tag',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }